import React from "react";
import { FaTemperatureHigh } from "react-icons/fa";
import { ImSwitch } from "react-icons/im";
import { WiHumidity } from "react-icons/wi";
import { GiBatteryPack } from "react-icons/gi";
import { AiOutlineColumnHeight } from "react-icons/ai";

function SensorIcon({ type }) {
  switch (type) {
    case "TEMPERATURE":
      return <FaTemperatureHigh />;
    case "HUMIDITY":
      return <WiHumidity size="2em" style={{ margin: "-0.5em" }} />;
    case "RELAY":
      return <ImSwitch />;
    case "BATTERY":
      return <GiBatteryPack />;
    case "WATERLEVEL":
      return <AiOutlineColumnHeight />;
    default:
      return null;
  }
}

export default SensorIcon;
